import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
}: SEOHeadProps) {
  useEffect(() => {
    const baseTitle = '洞洞杂货铺漫画 - 36漫画网';

    if (title) {
      document.title = `${title} - ${baseTitle}`;
    } else {
      document.title = `洞洞杂货铺漫画-漫画全集在线免费阅读-${baseTitle}`;
    }

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (description) {
      setMeta('description', description);
    }
    if (keywords) {
      setMeta('keywords', keywords);
    }
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }
    if (title) {
      setMeta('og:title', `${title} - ${baseTitle}`, true);
    }
    if (description) {
      setMeta('og:description', description, true);
    }
    setMeta('og:type', ogType, true);
    if (canonicalUrl) {
      setMeta('og:url', canonicalUrl, true);
    }
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }
    if (title) {
      setMeta('twitter:title', `${title} - ${baseTitle}`, false);
    }
    if (description) {
      setMeta('twitter:description', description, false);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage]);

  return null;
}